import { Component, Input } from "@angular/core";

@Component({
  selector: "app-error-something-wrong",
  template: `
    <div class="row justify-content-center stepper-header">
      <div class="col-md-8 application-error-section">
        <div class="error-icon">
          <i class="fa {{ icon }}" aria-hidden="true"></i>
        </div>
        <div *ngIf="error.title" class="error-title">
          {{ "error." + error.title | translate: error.translationParams }}
        </div>
        <div class="error-text" innerHtml="{{ 'error.' + error.message | translate: error.translationParams }}"></div>
      </div>
    </div>
  `,
})
export class SomethingWrongComponent {
  @Input() icon = "fa-exclamation-triangle";
  @Input() error = {
    title: "",
    message: "Something went wrong!",
    translationParams: {},
  };

  // brandInfo: BrandingInfo = {
  //   logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
  // };
}
